import { CreateEditInternalLayerVersionContent } from './CreateEditInternalLayerVersionContent';
import { useUscgMapContext } from './UscgMapContext';

export function EditLayerVersionPanel({ onBack }: { onBack: () => void }) {
  const { sidebarSelectedInternalLayer } = useUscgMapContext();

  if (!sidebarSelectedInternalLayer) {
    return null;
  }

  return (
    <>
      <div className="d-flex flex-column h-100 p-2">
        <div className="d-flex flex-column gap-3 flex-grow-1">
          <div className="rounded-pill bg-primary-800 text-white py-2 px-4 border border-white">
            Updating version for {sidebarSelectedInternalLayer.name}
          </div>
          <CreateEditInternalLayerVersionContent
            internalLayer={sidebarSelectedInternalLayer}
            onBack={onBack}
          />
        </div>
      </div>
    </>
  );
}
